import React, { useState, useEffect } from "react";
import Spinner from 'react-bootstrap/Spinner';
import {  useNavigate } from "react-router-dom";
import config from '../../config/config';
import { checkCustomer } from '../../components/utlity/checkCustomer';
import { checkPremiumMember } from '../../components/utlity/checkPremiumMember';
import { checkDownloadMerchDiscounnt } from '../../components/utlity/checkDownloadMerchDiscounnt';
import { openPremiumMemberSwal } from '../../components/utlity/openPremiumMemberSwal';
import {connect} from 'react-redux';
import * as downloadActions from '../../store/download/actions';
import * as customerAction from '../../store/customer/actions';
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

const DownloadAllButton = ({ downloadBundleSong, userProfile, entity_id, getCustomerDownloads, themeType, isCkExclusive, updateProfile }) => {

    const MySwal = withReactContent(Swal)
    const navigate = useNavigate();
    const [ downloadInProcess, setDownloadInProcess ] = useState(false);
    const [ canAccess, setCanAccess ] = useState(false);
    const [ isPremium, setIsPremium ] = useState(false);  
    
    useEffect(() => { 
        if(checkCustomer(userProfile)){
            setCanAccess(true);
        }
        if(checkPremiumMember(userProfile)){
            setIsPremium(true);
        }
    },[userProfile])

    const processDownload = (entity_id) => {
        downloadBundleSong({ entity_id: entity_id}).then(res => {
            setDownloadInProcess(false);
            // if(res.payload.response && res.payload.response.status === 403){
            //     // alert(res.payload.response.data.message);
            //     navigate('/subscription/plans');
            // } else 
            if(res.payload.response && res.payload.response.status === 403){
                MySwal.fire({
                    title: "Need Attention",
                    text: res.payload.response.data.message[0],
                    type: "danger",
                    allowOutsideClick: false,
                });
            } else if(res.payload.data) {
                getCustomerDownloads();
                if(checkDownloadMerchDiscounnt(userProfile)){
                    updateProfile({download_merch_code_displayed: 1});
                    MySwal.fire({
                        title: "Limited-Time Offer for the Club Killers Fam!",
                        html: `
                                    <p>WE APPRECIATE YOU BEING PART OF THE CREW!</p>
                                    <p>ENJOY A 15% OFF DISCOUNT OFF MERCH FOR THE NEXT 24 HOURS.</p>
                                    <p><strong>Use code:<strong> CKFAM15 at checkout</p>
                                    <p>Hurry—offer ends soon!</p>
                                `,
                        showCancelButton: false,
                        showConfirmButton: true,
                        allowOutsideClick: true
                    });
                }
                const data = res.payload.data;
                const zipUrl = `${config.downloadSelfUrl}tmp/${encodeURIComponent(data.zip)}`;
                window.location.assign(zipUrl);
                
            }
        });
    }

    const downloadBundle = (entity_id) => { 
        setDownloadInProcess(true);
        // if(isCkExclusive){
        //     if(isPremium){
        //         processDownload(entity_id);
        //     } else {
        //         setDownloadInProcess(false);
        //         openPremiumMemberSwal();
        //     }
        // } else {
            if(canAccess){ 
                processDownload(entity_id);
            } else {
                setDownloadInProcess(false);
                navigate('/subscription/plans')
            }
        // }
      }
    
    if(downloadInProcess){
        return <Spinner animation="border" variant="danger" size="sm" />
    } else {
        return (
            <span onClick={() => downloadBundle(entity_id)} className="cp" title="Download">
                <svg width="14" height="16" viewBox="0 0 14 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M10.9994 5.42871H12.1423C12.2939 5.42871 12.4392 5.48891 12.5464 5.59608C12.6535 5.70324 12.7137 5.84859 12.7137 6.00014V14.5716C12.7137 14.7231 12.6535 14.8685 12.5464 14.9756C12.4392 15.0828 12.2939 15.143 12.1423 15.143H1.85658C1.70503 15.143 1.55969 15.0828 1.45252 14.9756C1.34536 14.8685 1.28516 14.7231 1.28516 14.5716V6.00014C1.28516 5.84859 1.34536 5.70324 1.45252 5.59608C1.55969 5.48891 1.70503 5.42871 1.85658 5.42871H2.99944" stroke={themeType == 'dark-theme' ? "#FFF" : "#282A2D"} strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M6.99902 0.857422V10.0003" stroke={themeType == 'dark-theme' ? "#FFF" : "#282A2D"} strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M4.71387 7.71484L6.99958 10.0006L9.2853 7.71484" stroke={themeType == 'dark-theme' ? "#FFF" : "#282A2D"} strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            </span>
        )
    }
    
}
function mapStateToProps(state) {
    return {
        userProfile: state.customer.customerProfile,
        themeType: state.theme.theme,
    };
}
   
function mapDispatchToProps(dispatch) {
    return {
        downloadBundleSong: (data) => dispatch(downloadActions.downloadBundleSong(data)),
        getCustomerDownloads: () => dispatch(downloadActions.getCustomerDownloads()),
        updateProfile: (post) => dispatch(customerAction.updateProfile(post)),
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(DownloadAllButton);
  